import { gql } from "@apollo/client";export default gql`mutation deleteOrder($id: Int!) {
  deleteOrder: delete_subscription_order_by_pk(id: $id) {
    id
  }
}
`;
